var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSailorwheel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157.2 165.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#b3b3b3;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}.cls-2{stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 78.6,
    cy: 82.57,
    r: 17.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.6,
    y1: 20.69,
    x2: 78.6,
    y2: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.6,
    y1: 64.91,
    x2: 78.6,
    y2: 34.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.23,
    y1: 32.51,
    x2: 30.95,
    y2: 16.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.22,
    y1: 68.28,
    x2: 50.2,
    y2: 43.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.74,
    y1: 63.44,
    x2: 1.5,
    y2: 57.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.8,
    y1: 77.1,
    x2: 32.64,
    y2: 67.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.74,
    y1: 101.68,
    x2: 1.5,
    y2: 107.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.8,
    y1: 88.02,
    x2: 32.64,
    y2: 97.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42.23,
    y1: 132.62,
    x2: 30.95,
    y2: 148.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 68.22,
    y1: 96.85,
    x2: 50.2,
    y2: 121.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.6,
    y1: 163.63,
    x2: 78.6,
    y2: 144.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.6,
    y1: 130.88,
    x2: 78.6,
    y2: 100.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 126.25,
    y1: 148.15,
    x2: 114.97,
    y2: 132.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107,
    y1: 121.65,
    x2: 88.98,
    y2: 96.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.7,
    y1: 107.62,
    x2: 137.46,
    y2: 101.68
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "124.56 97.5 95.4 88.02 95.39 88.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 155.7,
    y1: 57.52,
    x2: 137.46,
    y2: 63.44
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "124.56 67.63 95.4 77.1 95.39 77.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 126.25,
    y1: 16.98,
    x2: 114.97,
    y2: 32.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 107,
    y1: 43.48,
    x2: 88.98,
    y2: 68.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.91,82.56c0,5.21-.82,10.24-2.35,14.94-3.18,9.8-9.41,18.22-17.56,24.15-7.97,5.81-17.79,9.23-28.4,9.23s-20.43-3.42-28.4-9.23c-8.15-5.92-14.38-14.35-17.57-24.15-1.53-4.7-2.35-9.72-2.35-14.93s.82-10.23,2.35-14.93c3.18-9.8,9.41-18.22,17.57-24.15,7.97-5.8,17.79-9.22,28.4-9.22s20.43,3.42,28.4,9.22c8.15,5.93,14.38,14.35,17.56,24.15,1.53,4.7,2.35,9.72,2.35,14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.46,63.44c-4.07-12.55-12.05-23.34-22.49-30.93-10.21-7.44-22.77-11.82-36.37-11.82s-26.16,4.38-36.37,11.82c-10.44,7.6-18.42,18.38-22.49,30.93-1.96,6.02-3.02,12.45-3.02,19.12s1.05,13.1,3.02,19.12c4.07,12.55,12.05,23.34,22.49,30.93,10.21,7.44,22.77,11.82,36.37,11.82s26.16-4.38,36.37-11.82c10.44-7.6,18.42-18.38,22.49-30.93,1.96-6.02,3.02-12.45,3.02-19.12s-1.05-13.1-3.02-19.12Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSailorwheel);
export default __webpack_public_path__ + "static/media/sailor wheel.ca09b046d6d9b99b83255adca1753c5d.svg";
export { ForwardRef as ReactComponent };